export const env = {
  // API Principal
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,

  // SIGMA API
  sigmaApiUrl: import.meta.env.VITE_API_WS,
  sigmaClientId: import.meta.env.VITE_API_USER,
  sigmaClientSecret: import.meta.env.VITE_API_PASSWORD,

  // Aplicación
  appName: import.meta.env.VITE_APP_NAME,
  appVersion: import.meta.env.VITE_APP_VERSION,
  enableDevtools: import.meta.env.VITE_ENABLE_DEVTOOLS === 'true',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

// Validación en tiempo de ejecución

if (!env.sigmaApiUrl) {
  throw new Error('VITE_API_WS no está definida en .env');
}

if (!env.sigmaClientId) {
  throw new Error('VITE_API_USER no está definida en .env');
}

if (!env.sigmaClientSecret) {
  throw new Error('VITE_API_PASSWORD no está definida en .env');
}

